import type { Data } from '@converge/cookie-management';

type GtmConsentValue = 'granted' | 'denied';

interface GtmConsentState {
    analytics_storage: GtmConsentValue;
    ad_storage: GtmConsentValue;
    ad_user_data: GtmConsentValue;
    ad_personalization: GtmConsentValue;
}

interface GtmWindow {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
}

const DEFAULT_GTM_CONSENT: GtmConsentState = {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
};

export function createGtmConsentDefaultScript(): string {
    return `
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'default', ${JSON.stringify(DEFAULT_GTM_CONSENT)});
`;
}

function ensureGtag(): (...args: unknown[]) => void {
    const gtmWindow = window as unknown as GtmWindow;
    gtmWindow.dataLayer = gtmWindow.dataLayer || [];
    gtmWindow.gtag =
        gtmWindow.gtag ||
        function gtag() {
            // Google gtag 的 dataLayer 命令使用 IArguments，不是普通业务事件数组。
            // eslint-disable-next-line prefer-rest-params
            gtmWindow.dataLayer!.push(arguments);
        };

    return gtmWindow.gtag;
}

function toGtmConsentValue(isAllowed: boolean): GtmConsentValue {
    return isAllowed ? 'granted' : 'denied';
}

export function updateGtmConsent(data: Data | null): void {
    if (typeof window === 'undefined') {
        return;
    }

    const analyticsConsent = toGtmConsentValue(data?.preference?.analytics === true);
    const advertisingConsent = toGtmConsentValue(data?.preference?.advertising === true);

    ensureGtag()('consent', 'update', {
        analytics_storage: analyticsConsent,
        ad_storage: advertisingConsent,
        ad_user_data: advertisingConsent,
        ad_personalization: advertisingConsent,
    });
}
